import html2canvas from "html2canvas";
import { useEffect, useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";

export default function VehicleStatusCard({ vehicle }) {
  const cardRef = useRef();
  const [base64Image, setBase64Image] = useState("");

  const vehicleUrl = `${window.location.origin}/vehicules/${vehicle.slug}`;

  useEffect(() => {
    const convertImageToBase64 = async () => {
      if (!vehicle?.imageUrls?.[0]) return;
      try {
        const response = await fetch(vehicle.imageUrls[0], {
          mode: "cors",
          cache: "no-cache",
        });
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          setBase64Image(reader.result);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Erreur conversion image base64:", error);
      }
    };
    convertImageToBase64();
  }, [vehicle?.imageUrls]);

  const generateStatus = () => {
    html2canvas(cardRef.current, {
      useCORS: true,
      scale: 2,
      backgroundColor: "#ffffff",
      width: 360,
      height: 720,
      windowWidth: 360,
      windowHeight: 720,
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = `status-${vehicle.marque}-${vehicle.modele}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });

  };

  const formatPrix = (prix) =>
    prix?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " FCFA";

  const getFiche = (key, fallback = "---") =>
    vehicle?.ficheTechnique?.[key] || fallback;

  return (
    <div className="text-center mb-5">
      <div
        ref={cardRef}
        className="mx-auto"
        style={{
          width: "360px",
          height: "720px",
          padding: "20px",
          borderRadius: "20px",
          backgroundColor: "#ffffff",
          color: "#000000",
          fontFamily: "'Segoe UI', sans-serif",
          position: "relative",
          boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
        }}
      >
        <img
          src="/logo192.png"
          alt="Logo"
          style={{ width: "90px", position: "absolute", top: "0px", right: "20px" }}
        />

        {base64Image ? (
          <div style={{ position: "relative", width: "100%", paddingTop: "56.25%", borderRadius: "12px", overflow: "hidden", marginTop: "50px", marginBottom: "10px" }}>
            <img
              src={base64Image}
              alt={`${vehicle.marque} ${vehicle.modele}`}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "200px",
                objectFit: "cover"
              }}
            />
          </div>

        ) : (
          <div
            style={{
              width: "100%",
              height: "200px",
              backgroundColor: "#ddd",
              borderRadius: "12px",
              marginTop: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="text-muted">Chargement image...</p>
          </div>
        )}

        <h2 style={{ fontWeight: 700, fontSize: "1.4rem", letterSpacing: 1 }}>
          {[vehicle.marque, vehicle.modele, vehicle.annee].filter(Boolean).join(" ").toUpperCase()}
        </h2>

        <div
          style={{
            backgroundColor: "#f5f5f5",
            color: "#000",
            borderRadius: "20px",
            padding: "6px 14px",
            fontSize: "0.9rem",
            margin: "10px auto",
            display: "inline-block",
            fontWeight: "500",
          }}
        >
          {getFiche("moteur", "Moteur ...")} / {getFiche("places", "...")} SEATS / {vehicle.kilometrage || "0 km"}
        </div>

        <p
          style={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            color: "#F7941E",
            marginTop: "10px",
            borderRadius: "20px",
            padding: "6px 14px",
            display: "inline-block",
            backgroundColor: "#000000",
          }}
        >
          {vehicle.prix && vehicle.prix > 0
            ? `Prix TTC: ${formatPrix(vehicle.prix)}`
            : "Prix à la demande"}
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            marginTop: "20px",
            fontSize: "0.9rem",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            🚗 <strong>{getFiche("puissance")}</strong> Ch
          </div>
          <div>⚙️ {getFiche("transmission", "Automatique")}</div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            marginTop: "10px",
            fontSize: "0.9rem",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            ⛽ {getFiche("carburant")}
          </div>
          <div>
            🛣️ {vehicle.ficheTechnique?.consommation
              ? `${vehicle.ficheTechnique.consommation} L/100km`
              : "... L/100km"}
          </div>
        </div>

        <div className="mt-4 text-center">
          <QRCodeCanvas value={vehicleUrl} size={80} includeMargin={true} level="M" />
          <p style={{ fontSize: "0.75rem", color: "#888", marginTop: "10px" }}>
            www.thebridgeofworld.com
          </p>
        </div>
      </div>

      <button className="btn btn-outline-dark mt-3" onClick={generateStatus}>
        Générer le statut visuel
      </button>
    </div>
  );
}
